import React from "react";
import { Link } from "react-router-dom";
import {
  FaYoutube,
  FaSpotify,
  FaInstagram,
  FaFacebookF,
  FaWhatsapp,
  FaLinkedinIn,
  FaXTwitter,
  FaApple,
  FaAmazon,
} from "react-icons/fa6";
import { SiYoutubemusic } from "react-icons/si";
import site from "../content/site.json";
import { externalLinkProps } from "../lib/links";

const ICON_MAP = {
  FaYoutube,
  FaSpotify,
  FaInstagram,
  FaFacebookF,
  FaWhatsapp,
  FaLinkedinIn,
  FaXTwitter,
  FaApple,
  FaAmazon,
  SiYoutubemusic,
};

const Footer = () => {
  const { brand, footer, social } = site;
  return (
    <footer
      data-testid="site-footer"
      className="bg-ivory-deeper border-t border-charcoal/10 mt-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20">
        <div className="flex flex-col items-center text-center gap-10">
          <Link
            to="/"
            data-testid="footer-logo-link"
            aria-label="TATTVAM home"
            className="block"
          >
            <img
              src={brand.logoFull}
              alt={brand.logoFullAlt}
              data-testid="footer-logo-full"
              className="h-16 md:h-20 w-auto"
            />
          </Link>

          <p className="text-sm tracking-[0.32em] font-medium text-muted_gold">
            {brand.tagline}
          </p>

          {/* Social icons — subtle */}
          <div
            data-testid="footer-social"
            className="flex items-center gap-8 text-charcoal"
          >
            {social.map((s) => {
              const Icon = ICON_MAP[s.icon];
              if (!Icon) return null;
              return (
                <a
                  key={s.name}
                  href={s.href}
                  {...externalLinkProps(s.href)}
                  aria-label={s.name}
                  data-testid={s.testId}
                  className="hover:text-muted_gold hover:scale-110 transition-all duration-300"
                >
                  <Icon size={22} />
                </a>
              );
            })}
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-charcoal/15 flex flex-col md:flex-row items-center justify-between gap-3 text-center md:text-left">
          <p
            data-testid="footer-copyright"
            className="text-sm text-charcoal-soft tracking-wide"
          >
            {footer.copyright}
          </p>
          <p
            data-testid="footer-produced-by"
            className="text-xs text-charcoal-soft tracking-[0.2em] font-medium"
          >
            {footer.producedBy}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
